angular
	.module 'App.Module.Pusher', []
	.config ($stateProvider) ->
		$stateProvider
			.state 'pusher',
					url: '/pusher'
					views:
						'main@':
							controller: 'PusherController'
							controllerAs: 'vm'
							templateUrl: '@app/pusher/pusher.view.html'
